module.exports = __webpack_public_path__ + "906fd2fb59d81df2b021aa7a75627db3.svg";